export default __webpack_public_path__ + "/assets/gallery-01.jpg";